module.exports = __webpack_public_path__ + "wf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/wf.svg
// module id = 888
// module chunks = 0